module.exports = __webpack_public_path__ + "img/sideflag.2e2c939.png";